import { render, staticRenderFns } from "./footer.vue?vue&type=template&id=fda3403a&scoped=true"
import script from "./footer.vue?vue&type=script&lang=js"
export * from "./footer.vue?vue&type=script&lang=js"
import style0 from "./footer.vue?vue&type=style&index=0&id=fda3403a&prod&lang=scss&scoped=true"
import style1 from "./footer.vue?vue&type=style&index=1&id=fda3403a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fda3403a",
  null
  
)

export default component.exports